import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: []
  },
  getters: {
    list: state => state.list
  },
  actions: {
    fetchSearch({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Inventory/api/StockTaking")
          .then(r => {
            resolve(r.data);
          })
          .catch(e => {
            reject(e.response.data);
          });
      });
    },
    create({ commit, dispatch }, model) {
      return ajax.post("Inventory/api/StockTaking", model).then(() => {});
    },
    updateWarehouseHanding({ commit, dispatch }, model) {
      return ajax.put("Inventory/api/StockTaking", model).then(() => {});
    },
    createCountingTag({ commit, dispatch }, model) {
      return ajax.post("Inventory/api/CountingTag", model).then(() => {});
    },
    createGroup({ commit, dispatch }, model) {
      return ajax.post("Inventory/api/CountingTag/group", model).then(() => {});
    },
    submitListSerials({ commit, dispatch }, model) {
      return ajax
        .post("Inventory/api/CountingTag/group/Inventory-items", model)
        .then(() => {});
    },
    findDiscrepanct({ commit, dispatch }, model) {
      return ajax.put("Inventory/api/CountingTag", model).then(() => {});
    },
    removeCountingTag({ commit, dispatch }, id) {
      return ajax
        .delete(
          "Inventory/api/CountingTag",
          { data: { id: id } },
          { headers: { "Content-Type": "application/json" } }
        )
        .then(() => {
          //dispatch('fetch')
        });
    },
    completeCountingGroup({ commit, dispatch }, model) {
      return ajax
        .put("Inventory/api/CountingTag/complete/group", model)
        .then(() => {
          //dispatch('fetch')
        });
    },
    completeCounting({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Inventory/api/CountingTag/complete", model)
          .then(r => {
            commit("setDetails", r.data);
            resolve(r.data);
          })
          .catch(e => {
            reject(e.response.data);
          });
      });
    },
    fetchListBarcode({ commit }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .get(
            "Inventory/api/CountingTagQuery/" +
              model.idTag +
              "/groups/" +
              model.idGroup +
              "/inventory-items?Take=10000&Skip=0"
          )
          .then(res => {
            commit("setDetails", res.data);
            resolve(res.data.data);
          })
          .catch(e => reject(e));
      });
    }
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    }
  }
};
